<template>
    <div class="app-container calendar-list-container">
      <el-card class="box-card" v-if="type == 1">
          <div slot="header" class="clearfix">
              <el-button  class="filter-item filter-item1" type="primary" size="mini" icon="el-icon-edit-outline" @click="handleChange">编辑
              </el-button>
          </div>
          <div style="width:400px;float: left;">
              <el-form ref="form" :model="form" label-width="100px">
                  <el-form-item label="昵称" class="margin_form" label-width="100px">
                      {{form.name?form.name:'-'}}       
                  </el-form-item>
                  <el-form-item label="性别" class="margin_form" label-width="100px">
                      {{form.sex == 1?"男":(form.sex==0?"女":'-')}}   
                  </el-form-item>
                    <el-form-item label="E-mail" class="margin_form" label-width="100px">
                      {{form.email?form.email:'-'}}   
                  </el-form-item>
                  <el-form-item label="手机号" class="margin_form" label-width="100px">
                        {{form.phone?form.phone:'-'}} <span @click="updatephone" style="padding: 15px;color: #409eff;cursor: pointer;">修改</span> 
                  </el-form-item>
                  <el-form-item label="密码" label-width="100px">
                    <span @click="updatepwd" style="padding: 15px;color: #409eff;cursor: pointer;">修改</span> 
                  </el-form-item>
              </el-form>
          </div>
            <div style="width:400px;float: left;">
              <img :src="form.avatar" style="width: 150px;margin-top: 25px;">
          </div>
      </el-card>
      <el-card class="box-card" v-show="type == 2">
           <div slot="header" class="clearfix">
             修改手机号
          </div>
          <div style="width:600px;float: left;">
              <el-form :model="updatePhoneOldForm"  :rules="rulesphone" ref="updatePhoneOldForm" label-width="100px">
                  <el-form-item label="老手机号"  label-width="100px" prop="phone">
                    <el-input v-model.number="updatePhoneOldForm.phone" disabled  autocomplete="off"></el-input>     
                  </el-form-item>
                  <el-form-item label="验证码" label-width="100px" prop="cord">
                    <el-input v-model.number="updatePhoneOldForm.cord" autocomplete="off">
                        <el-button slot="append" @click="getyzm(1)">获取验证码</el-button>
                    </el-input>  
                  </el-form-item>
                  <el-form-item class="formbtn">
                    <el-button type="primary" size="mini" @click="submitForm">下一步</el-button>
                    <el-button size="mini" @click="resetForm">返回</el-button>
                </el-form-item>
              </el-form>
          </div>
      </el-card>
      <el-card class="box-card" v-show="type == 4">
           <div slot="header" class="clearfix">
             修改手机号
          </div>
          <div style="width:600px;float: left;">
              <el-form :model="updatePhoneNewForm" :rules="rulesphone" ref="updatePhoneNewForm" label-width="100px">
                  <el-form-item label="新手机号" label-width="100px" prop="phone">
                    <el-input v-model.number="updatePhoneNewForm.phone" autocomplete="off"></el-input>     
                  </el-form-item>
                  <el-form-item label="验证码" label-width="100px" prop="cord">
                    <el-input v-model.number="updatePhoneNewForm.cord" autocomplete="off">
                        <el-button slot="append" @click="getyzm(2)">获取验证码</el-button>
                    </el-input>  
                  </el-form-item>
                  <el-form-item class="formbtn">
                    <el-button type="primary" size="mini" @click="submitForm1">修改</el-button>
                    <el-button size="mini" @click="resetForm">返回</el-button>
                </el-form-item>
              </el-form>
          </div>
      </el-card>
       <el-card class="box-card" v-show="type == 3">
           <div slot="header" class="clearfix">
             修改密码
          </div>
          <div style="width:600px;float: left;">
             <avue-form ref="formpwd" v-model="formpwd" :rules="rules" :option="option">
                <template slot="menuForm">
                    <el-button  @click="handleEmpty">取 消</el-button>
                    <el-button type="primary" @click="change_pwd">确 定</el-button>
                </template>
            </avue-form>
          </div>
      </el-card>
       <updaramy ref="child" @refresh="refresh"></updaramy>
    </div>
</template>

<script>
import { dealElement } from '@/util/util'
import {validatePass,validatePass2,validatepassold,phone} from '@/util/Format'
import {objKeySort} from '@/util/ajaxsign'
import {getImgLink} from '@/config/env'
import {changeUserPwd,phoneyzm,ruleskey,newphone} from '@/api/admin/user'
import updaramy from './updatamy.vue'
import {logout} from '@/api/admin/login'

export default {
    components: {updaramy},
  data() {
    return {
      form : {
        name : '',
        phone : '',
        sex : '',
        email : '',
        avatar : '',
      },
      sigen : '',
      session : {},
      type : 1,
      dialogVisible: false,
      formpwd : {},
      updatePhoneOldForm : {
        phone : '',
        cord : ''
      },
      updatePhoneNewForm : {
        phone : '',
        cord : ''
      },
      rules : {
        
      },
      rulesphone : {
         phone: [
            {required: true, message: '请输入手机号', trigger: 'blur' },
          ],
          cord: [
            {required: true, message: '请输入验证码', trigger: 'blur' },
          ]
      },
      option:{
          emptyBtn:false,
          submitBtn:false,
          submitText : '确定',
          column: [{
            label: "旧密码",
            prop: "oldPassword",
            type : "password",
            visdiplay : true,
            span:24,
            rules: [{ validator: validatepassold, trigger: 'blur' }]
        },{
            label: "新密码",
            prop: "newPassword",
            type : "password",
            visdiplay : true,
            span:24,
            rules: [{ validator: validatePass, trigger: 'blur' }]
        },{
            label: "确认密码",
            prop: "password1",
            type : "password",
            visdiplay : true,
            span:24,
            rules: [{ validator: validatePass2, trigger: 'blur' }]
        }],
      },
    }
  },
  created(){
   this.getcompany();
  }, 
  methods: {
    refresh(){
      this.form.name = '';
      this.form.phone = '';
      this.form.sex =  '';
      this.form.email =  '';
      this.form.avatar = '';
      this.getcompany()
    },
     //获取企业信息
    getcompany(){
      this.session = JSON.parse(window.sessionStorage.getItem("userInfo"));
      this.form.name = this.session.name;
      this.form.phone = this.session.phone;
      this.form.sex =  this.session.sex;
      this.form.email =  this.session.email;
      this.form.avatar = this.session.avatar?getImgLink(this.session.avatar):'/img/default-avatar.png';
    },
    submitForm(){
      this.$refs.updatePhoneOldForm.validate((valid) => {
          if (valid) {
            ruleskey(objKeySort({phone:this.updatePhoneOldForm.phone,code : this.updatePhoneOldForm.cord})).then(res => {
              if(res.data.code==200){
                this.sigen = res.data.data;
                this.updatePhoneOldForm.phone = undefined;
                this.updatePhoneOldForm.cord = undefined;
                this.type = 4;
              }
              
          })
        }else{
          return false;
        }
      });
      
    },
    //返回
    resetForm() {
      this.type = 1;
    },
    //修改个人信息
    handleChange(){
      // 子组件按钮的是否允许操作
      this.$refs.child.dialog();
    },

    //取消修改密码
    handleEmpty(){
      this.type = 1;
    },

    //修改手机号
    updatephone(){
      this.type =2;
      this.updatePhoneOldForm.phone = this.form.phone;
    },
    //修改密码
    updatepwd(){
      this.type =3;
    },
    //提交修改密码
    change_pwd(){
       this.$refs.formpwd.validate(vaild=>{
            if(vaild){
                  changeUserPwd(objKeySort(this.formpwd)).then(res => {
                    this.type = 1;
                    if(res.data.code==200){
                      this.$message({
                        title: '修改密码成功',
                        message: '修改密码成功，请重新登录',
                        type: 'success',
                        duration: 3000
                       })
                      //修改后退出账号，重新登录
                      setTimeout( function(){logout(objKeySort()).then(response => {
                        sessionStorage.clear();
                        window.location.href = window.location.href.split('#')[0]+"index/login.html"
                      })},3000);
                     
                    }
                    
                })
            }
        })
    },

    //获取验证码
    getyzm(type){
      let phone = '';
      if(type===1){
        phone = this.updatePhoneOldForm.phone;
        if(!phone){
          this.$refs.updatePhoneOldForm.validateField('phone');
          return ;
        }
      }else{
        phone = this.updatePhoneNewForm.phone;
        if(!phone){
          this.$refs.updatePhoneNewForm.validateField('phone');
          return ;
        }
      }
     
      phoneyzm(objKeySort({phone:phone})).then(res => {
        if(type===1){
          this.updatePhoneOldForm.cord = res.data.data;
        }else{
          this.updatePhoneNewForm.cord = res.data.data;
        }
      })
      
      
    },

    //修改手机号
    submitForm1(){
      this.$refs.updatePhoneNewForm.validate((valid) => {
          if (valid) {
            newphone(objKeySort({phone:this.updatePhoneNewForm.phone,code : this.updatePhoneNewForm.cord,key:this.sigen})).then(res => {
              window.sessionStorage.setItem( "userInfo", JSON.stringify(res.data.data));
              this.type = 1;
              this.getcompany()
            })
          }else{
            return false;
          }
      });
    }
   
  }
}
</script>

<style lang="scss" scoped>
    .formwidth{
        width:38%;
    }
    .cardtop{
        margin-bottom: 20px;
    }
    .btn{
        margin-left: 150px;
        margin-bottom: 10px;
    }
    .margin_form{
      margin-bottom: 0;
    }
    .formbtn{
      margin-top:15px;
    }
</style>
